import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/our-story", label: "Our Story", key: "our-story" },
  { to: "/schedule", label: "Schedule", key: "schedule" },
  { to: "/travel", label: "Travel & Hotels", key: "travel" },
  { to: "/dress-code", label: "Dress Code", key: "dress-code" },
  { to: "/rsvp", label: "RSVP", key: "rsvp" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const { hiddenPages } = useSettings();
  const links = LINKS.filter((l) => !l.key || !hiddenPages.includes(l.key));
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-cream/80 border-b-2 border-orange/40" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="font-display text-xl md:text-2xl text-ink" data-testid="nav-logo">
          D <span className="text-orange">&amp;</span> M
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `font-grotesk font-medium text-sm px-3 py-2 rounded-full transition-transform duration-200 hover:-translate-y-0.5 ${
                  isActive ? "bg-yellow text-ink border-2 border-ink" : "text-ink/80 hover:text-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <button
          className="md:hidden text-ink p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden border-t border-ink/20 bg-cream"
            data-testid="nav-mobile-menu"
          >
            <div className="px-5 py-4 flex flex-col gap-1">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className={({ isActive }) =>
                    `font-grotesk font-semibold text-lg py-2 ${isActive ? "text-orange" : "text-ink"}`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
